module.exports = __webpack_public_path__ + "static/media/morava.9877cc3f.jpg";